export default __webpack_public_path__ + "static/media/review_location.2b0cef13.svg";